/**
 * Validation pure d un fichier upload (separe du composant pour testabilite).
 * Limite : 25MB, MIME whitelist (PDF/JPG/PNG).
 */

/** @type {number} */
export const MAX_BYTES = 25 * 1024 * 1024;
/** @type {ReadonlyArray<string>} */
export const ALLOWED_MIME = Object.freeze(['application/pdf', 'image/jpeg', 'image/png']);

/**
 * Valide un objet File-like (must have size + type).
 *
 * @param {{ size: number, type: string } | null | undefined} file
 * @returns {string | null} - message d erreur ou null si OK
 */
export function validateUpload(file) {
  if (!file) return 'Aucun fichier';
  if (typeof file.size !== 'number' || typeof file.type !== 'string') return 'Fichier invalide';
  if (file.size <= 0) return 'Fichier vide';
  if (file.size > MAX_BYTES) return 'Fichier > 25MB';
  if (!ALLOWED_MIME.includes(file.type)) return 'Format non supporte (PDF/JPG/PNG)';
  return null;
}
